exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mod[data-v-49ea675e]{margin-top:16px;display:flex;flex-direction:column;align-items:center}.mod .shake_egg[data-v-49ea675e]{width:344px;height:61px;background-size:contain;background-repeat:no-repeat;background-position:50%;background-color:#f2f2f2;border-radius:30px}", ""]);

// exports
